import { X, Sparkles, ArrowLeft, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { useLanguage } from "../../contexts/LanguageContext";

export const ExitPopup = ({ isOpen, onClose }) => {
  const { language, direction, translations: t } = useLanguage();
  const ArrowIcon = direction === 'rtl' ? ArrowLeft : ArrowRight;
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <motion.div
        className="bg-white rounded-3xl p-8 md:p-12 max-w-lg w-full relative"
        onClick={(e) => e.stopPropagation()}
        initial={{ opacity: 0, scale: 0.9, y: -20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
      >
        <button 
          onClick={onClose} 
          className="absolute top-4 left-4 w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-[#2C2C2C]/50 hover:text-[#2C2C2C] hover:bg-gray-200 transition-colors"
          aria-label={language === 'he' ? "סגור" : "Close"}
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center">
          <div className="w-20 h-20 rounded-full bg-[#C4956A]/10 flex items-center justify-center mx-auto mb-6">
            <Sparkles className="w-10 h-10 text-[#C4956A]" />
          </div>
          <h3 className="font-['Heebo'] text-2xl md:text-3xl font-bold text-[#2C2C2C] mb-4">
            {t.exitPopup.title}
          </h3>
          <p className="text-[#2C2C2C]/70 mb-6 text-lg">
            {t.exitPopup.subtitle}
          </p>
          
          <a href="#contact" onClick={onClose}>
            <Button className="w-full rounded-full py-6 bg-[#C4956A] hover:bg-[#b38559] text-white text-lg">
              {t.exitPopup.cta}
              <ArrowIcon className="w-5 h-5 mx-2" />
            </Button>
          </a>
          
          <button 
            onClick={onClose}
            className="mt-4 text-[#2C2C2C]/50 hover:text-[#2C2C2C] text-sm transition-colors"
          >
            {t.exitPopup.dismiss}
          </button>
        </div>
      </motion.div>
    </div>
  );
};
